import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { MagnifyingGlassIcon, UserPlusIcon } from '@heroicons/react/24/solid';
import AddActivityDialog from './AddActivityDialog';
import { useParams } from 'react-router-dom';

export const ActivitiesListHeader: React.FC = () => {
  const [t] = useTranslation('locale');
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get('search') ?? '');
  const [isAddActivityDialogOpen, setIsAddActivityDialogOpen] = useState(false);
  const { agentId = '' } = useParams();

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setSearchParams((prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        if (value) {
          newParams.set('search', value);
        } else {
          newParams.delete('search');
        }
        return newParams;
      });
    }, 500),
    [setSearchParams],
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    const { value } = e.target;
    debouncedSearch(value);
  };

  const handleAddButtonClick = () => {
    setIsAddActivityDialogOpen(true);
  };

  const handleActivityCreated = (newActivity: any) => {
    if (searchParams.has('search')) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('search');
      setSearchParams(newSearchParams);
    }
  };

  return (
    <div className="flex h-[18hv] flex-col gap-2 px-2 py-4 md:h-[14vh]">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">{t('chat_dashboard.title')}</h2>
        {/* <button 
          className=" p-2"
          onClick={handleAddButtonClick}
        >
          <UserPlusIcon className="h-5 w-5 text-black" />
        </button> */}
      </div>
      <label className="max-w-xs input flex w-full flex-row items-center rounded-full bg-custom-surface-200">
        <input
          value={search}
          onChange={handleChange}
          type="text"
          className="grow bg-transparent text-sm"
          placeholder={t('chat_dashboard.search')}
        />
        <MagnifyingGlassIcon className="h-5 w-5 text-black" />
      </label>

      <AddActivityDialog
        open={isAddActivityDialogOpen}
        onClose={() => setIsAddActivityDialogOpen(false)}
        agentId={agentId}
        searchValue={search}
        onActivityCreated={handleActivityCreated}
      />
    </div>
  );
};
